var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24023 2.06372C5.10023 2.06372 1.74023 5.42372 1.74023 9.56372C1.74023 13.7037 5.10023 17.0637 9.24023 17.0637C13.3802 17.0637 16.7402 13.7037 16.7402 9.56372C16.7402 5.42372 13.3802 2.06372 9.24023 2.06372ZM9.24023 15.5637C5.93273 15.5637 3.24023 12.8712 3.24023 9.56372C3.24023 6.25622 5.93273 3.56372 9.24023 3.56372C12.5477 3.56372 15.2402 6.25622 15.2402 9.56372C15.2402 12.8712 12.5477 15.5637 9.24023 15.5637ZM7.36523 12.9387L12.6152 9.56372L7.36523 6.18872V12.9387Z",
    fill: "#534AD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.c2caf10474f756b205b13091ef739dba.svg";
export { ForwardRef as ReactComponent };